import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import StyledTextField from 'components/commons/StyledTextField';
import StyledAutoComplete from 'components/commons/StyledAutoComplete';

const TextFieldComponent = (props) => {
    let inputValue = props.params.inputProps.value;
    if ((props.selected.label === 'Min' || props.selected.label === 'Max') && props.selected.value === '') {
        inputValue = '';
    }

    return (
        <StyledTextField
            {...props.params}
            inputProps={{
                ...props.params.inputProps,
                value: inputValue,
            }}
            label={props.label}
            size="small"
            type="button"
            isHighlighted={props.selected.value}
        />
    );
};

function RpRangeSelect({
    minOptions,
    maxOptions,
    minValue,
    maxValue,
    onChange,
    labelMin = 'Min',
    labelMax = 'Max',
    sx,
}) {
    // Ensure minValue and maxValue are option objects
    const minValueObj = minOptions.find(opt => opt.value === minValue) || { value: '', label: 'Min' };
    const maxValueObj = maxOptions.find(opt => opt.value === maxValue) || { value: '', label: 'Max' };

    return (
        <Box sx={{display: 'flex', gap: 2}}>
            <StyledAutoComplete
                disablePortal
                options={minOptions}
                value={minValueObj}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onChange={(_, value) => onChange({ min: value, max: maxValueObj })}
                freeSolo
                disableClearable
                renderInput={(params) => (
                    <TextFieldComponent
                        params={params}
                        label={labelMin}
                        selected={minValueObj}
                    />
                )}
                sx={sx || {width: 120}}
                getOptionDisabled={(option) =>
                    maxValueObj && option.value !== '' && maxValueObj.value !== '' && parseInt(option.value, 10) > parseInt(maxValueObj.value, 10)
                }
                forcePopupIcon
            />
            <StyledAutoComplete
                disablePortal
                options={maxOptions}
                value={maxValueObj}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onChange={(_, value) => onChange({ min: minValueObj, max: value })}
                freeSolo
                disableClearable
                renderInput={(params) => (
                    <TextFieldComponent
                        params={params}
                        label={labelMax}
                        selected={maxValueObj}
                    />
                )}
                sx={sx || {width: 120}}
                getOptionDisabled={(option) =>
                    minValueObj && option.value !== '' && minValueObj.value !== '' && parseInt(option.value, 10) < parseInt(minValueObj.value, 10)
                }
                forcePopupIcon
            />
        </Box>
    );
}

RpRangeSelect.propTypes = {
    minOptions: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    maxOptions: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    minValue: PropTypes.string,
    maxValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    labelMin: PropTypes.string,
    labelMax: PropTypes.string,
};
export default RpRangeSelect;